import { defineStore } from 'pinia'
import { ref } from '@nuxtjs/composition-api'
import { IStock } from './types'
import { getStocks } from './../api/index'

export const useStocksModel = defineStore('stocks', () => {
  const stocksList = ref<IStock[]>([])

  const fetch = async (code: string) => {
    const stocksResult = await getStocks(code)
    stocksList.value = stocksResult.result ? stocksResult.result : []
  }

  return {
    stocksList,
    fetch
  }
})
